import { render, staticRenderFns } from "./f2.vue?vue&type=template&id=62e1a807&scoped=true&"
import script from "./f2.vue?vue&type=script&lang=js&"
export * from "./f2.vue?vue&type=script&lang=js&"
import style0 from "./f2.vue?vue&type=style&index=0&id=62e1a807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e1a807",
  null
  
)

component.options.__file = "f2.vue"
export default component.exports